import{jsxs as t,jsx as e}from"react/jsx-runtime";import n from"../../assets/icons/box_round.svg.js";import o from"styled-components";import{COLORS as r}from"../../constants/Theme.js";import{TitleRegular as i,BodySecondary as s}from"../TypographyStyle.js";const c=o=>{let{title:c,subtitle:m}=o;return t(l,{children:[e(n,{width:48,height:48}),e(i,Object.assign({style:{marginTop:8}},{children:c})),e(s,Object.assign({style:{color:r.content.secondary,marginTop:4}},{children:m}))]})},l=o.div`
	height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
`;export{c as EmptyState};
